"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWebsiteSchema = void 0;
/**
 *
 * @returns The WebSite schema JSON string.
 */
function getWebsiteSchema() {
    return JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        url: 'https://www.chewy.com',
        potentialAction: {
            '@type': 'SearchAction',
            target: 'https://www.chewy.com/s?query={search_term_string}&src=searchbox_google&nav-submit-button=',
            'query-input': 'required name=search_term_string',
        },
    });
}
exports.getWebsiteSchema = getWebsiteSchema;
//# sourceMappingURL=website-schema.js.map